

import {
  DxDataGrid, DxColumn, DxEditing, DxPaging, DxMasterDetail,
} from 'devextreme-vue/data-grid';
import { DxToast } from 'devextreme-vue/toast';
import GiroService from '../services/giro-service';
import notify from 'devextreme/ui/notify';
import MasterDetail from './girodetail.vue';
export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxPaging,
    DxToast,
    DxMasterDetail,
    MasterDetail,
  },
  data() {
    return {
      dataSourceCompany: null,
      empresa: {},
      events: [],
      giroService: null,
      isVisible: false,
      message: '',
      type: 'info',
    };
  },
  created() {
    this.giroService = new GiroService();
  },
  mounted() {
    this.giroService.getGirosGenerales().then(data => {
      data.forEach(
        element => {

          if (element.bactivo == 1) {
            element.bactivo = true;
          } else {
            element.bactivo = false;
          }

        });
      this.dataSourceCompany = data;

    });

  },
  methods: {
    logEvent(eventName) {
      this.events.unshift(eventName);
    },
    editRegister(e) {
      let vactivo = e.data.bactivo == true ? 1 : 0;
      let myJSON = JSON.stringify({
        pid: e.data.id,
        pdescripcion: e.data.descripcion,
        pbactivo: vactivo,
      });

      this.giroService.updateGiro(myJSON).then(() => {
        this.type = 'success';
        this.message = 'Se ha actualizado el registro';
        this.isVisible = true;
      });

    },
    onInitNewRow(e) {
            e.data.bactivo = true;
        },
    deleteRegister(e) {

      let myJSON = JSON.stringify({
        pid: e.data.id,
      });

      this.giroService.deleteGiro(myJSON).then(() => {
        this.type = 'success';
        this.message = 'Se ha eliminado el registro';
        this.isVisible = true;
      });
    },
    createRegister(e) {
      let vactivo = e.data.bactivo == true ? 1 : 0;
      let myJSON = JSON.stringify({
        pdescripcion: e.data.descripcion,
        pbactivo: vactivo,
      });

      if (e.data.descripcion == '' || e.data.descripcion == null) {
        notify('Capture la descripcion', "error", 2000);
      } else {
        this.giroService.createGiro(myJSON).then(() => {
          this.type = 'success';
          this.message = 'Se ha creado el registro';
          this.isVisible = true;
        });
      }


    },
  },
};
